export default __webpack_public_path__ + "static/media/Tread-Blue.f6192428.svg";